import React from "react"
import { Container, Nav, Navbar } from "react-bootstrap"
import { Link } from "gatsby"
import HeaderLogo from "../HeaderLogo/HeaderLogo"
import useBurgerMenu from "../../hooks/useBurgerMenu";
// import useSiteConfig from "../../hooks/useSiteConfig"
const { CTALink } = require("@starberry/gatsby-theme-utils/Modules/CTALinkModule")

const HeaderMenu = ({ handleToggle, isVisible }) => {
  const { menu_data } = useBurgerMenu();
  return (
    <div className="header-bottom">
      <Navbar expand="xl" className="">
        <HeaderLogo />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="ms-auto d-flex align-items-center">
            <ul className="list-inline navbar-menu-list">
              {menu_data?.length > 0 &&
                menu_data.map(({ node }, i) => (
                  <li className={`list-inline-item ${menu_data?.length === i+1 ? "last" : ""}`} key={i}>
                    <CTALink link={node?.link} target_window={node?.link?.target_window}>
                      {node.title}
                    </CTALink>
                  </li>
                ))}
            </ul>
          </Nav>
        </Navbar.Collapse>

        <div className="ms-auto d-xl-none d-md-block d-none header-contact-btn">
          <Link to="/contact-us/" className="button button-outline">Contact us</Link>
        </div>
        <ul className="list-inline nav-menu-list d-xl-none">
          <li className="list-inline-item burger-menu-list">
            <button onClick={() => handleToggle()} aria-label="Burger Menu Icon">
              {isVisible ? (
                <i className="icon icon-burger-menu-close"></i>
              ) : (
                <i className="icon icon-burger-menu"></i>
              )}
            </button>
          </li>
        </ul>
      </Navbar>
    </div>
  );
};

export default HeaderMenu;
